import { faLightbulb } from "@fortawesome/pro-light-svg-icons";
import { faTimes } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef, useCallback } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";

import { Tooltip } from "common/components/tooltip";
import { pazienHistory } from "common/components/pazienHistory";

import { HeaderActions, Icon, NotificationPopup, PanelHeader, PanelIcon, Title, TopbarIcon } from "./notificationPopup";

export const TutorialsPopup = function({ onVisibilityChange }) {
    const currentPage = useSelector((state) => state.common.pageName);
    const feeReports = useSelector((state) => state.common.user.optIns.feeReports);
    const popupRef = useRef();
    
    const closePopup = useCallback(() => {
        popupRef.current?.close();
    }, []);
    
    const navigateToFees = useCallback(() => {
        pazienHistory.navigateWithParams("preferences/preferences", { trigger: true });
        closePopup();
    }, [closePopup]);
    
    const launchFlow = function(flow) {
        return () => {
            if (window.Appcues) {
                window.Appcues.show(flow);
            }
        };
    };
    
    const tutorials = {
        authorizations: [
            {
                title: "Pivot tables",
                description: "Quickly manipulate your data to easily understand where you’re doing well and where you can improve.",
                onClick: launchFlow("-M3v9yCUQ5fpCPhrbaer")
            },
            {
                title: "Date comparisons",
                description: "Compare your payments performance across multiple date ranges within the analytics sections.",
                onClick: launchFlow("-M2oHrwjgq8M673m8vka")
            }
        ]
    };
    
    if (feeReports) {
        tutorials.fees = [{
            title: "Fee detail reports",
            description: feeReports.active
                ? <div>You have requested to receive fee detail reports from Worldpay. <a> Manage preferences </a></div>
                : <div>Worldpay offers monthly transaction-level fee reports upon request. <a> Learn more </a></div>,
            onClick: navigateToFees
        }];
    }
    
    if (!tutorials[currentPage]) {
        return (
            <TopbarIcon>
                <Tooltip title="There are no tips or tutorials for this page" position="left">
                    <Icon $indicator={false} $iconStyle="university">
                        <FontAwesomeIcon icon={faLightbulb}/>
                    </Icon>
                </Tooltip>
            </TopbarIcon>
        );
    }
    
    return (
        <NotificationPopup
            ref={popupRef}
            icon={faLightbulb}
            iconStyle="university"
            title="Tips and tutorials"
            onVisibilityChange={onVisibilityChange}
            hasIndicator
        >
            <TutorialsContent>
                <PanelHeader>
                    <Title>Tips and tutorials</Title>
                    <HeaderActions>
                        <PanelIcon onClick={closePopup}><FontAwesomeIcon icon={faTimes} /></PanelIcon>
                    </HeaderActions>
                </PanelHeader>
                <div className="tutorials">
                    {tutorials[currentPage].map((t) => (
                        <div key={t.id} className="item" onClick={t.onClick}>
                            <div className="title">{t.title}</div>
                            <div className="description">{t.description}</div>
                        </div>
                    ))}
                </div>
            </TutorialsContent>
        </NotificationPopup>
    );
};

const TutorialsContent = styled.div`
    position: relative;

    .close-header {
        position: absolute;
        padding: 0;
        height: 64px;
        top: 20px;
        right: 10px;
    }

    header {
        width: 100%;
        padding: 20px;
        height: 60px;
        background-color: ${(props) => props.theme.colors["canvas-white"]};
        font-size: ${(props) => props.theme.headerFontSize};
        color: ${(props) => props.theme.colors["gray-dark"]};
        border-bottom: 1px solid ${(props) => props.theme.colors["gray-soft"]};
    }

    .tutorials {
        .item {
            cursor: pointer;
            padding: 20px;
            margin: 10px;
            background-color: ${(props) => props.theme.colors["canvas-white"]};
            border: ${(props) => props.theme.colors["gray-soft"]};

            .title {
                font-size: ${(props) => props.theme.fontSizeLarge};
                color: ${(props) => props.theme.colors["gray-dark"]};
            }

            .description {
                font-size: ${(props) => props.theme.fontSizeLarge};
                color: ${(props) => props.theme.colors["gray-dark"]};
            }
        }
    }
`;
